export default {
  namespaced: true,
  state: {
    show: null
  },
  mutations: {
    setShow (state, bool) {
      state.show = bool
    },
    toggle (state) {
      state.show = !state.show
    }
  }
}
